import { Signal } from "signals";
import LoadbarComponent from "slotworks/components/preloader/loadbar-component";
import { FileLocation } from "slotworks/config/asset-config-schema";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import Contract from "slotworks/utils/contracts/contract";

class PreloaderComponent {

    public onProgress: Signal = new Signal();

    protected loadBar: LoadbarComponent;

    private progressText: PIXI.Text;

    public init(files: FileLocation[]) {
        if (Layers.Background.hasScene("preloader")) {
            Layers.Background.setScene("preloader").execute();
        }

        let bar: PIXI.DisplayObject;
        let chaser: PIXI.Sprite;

        if (Layers.Menus.hasScene("preloader")) {
            Layers.Menus.setScene("preloader").execute();

            // Graphics
            bar = Layers.Menus.getSprite("loader_bar");
            chaser = Layers.Menus.getSprite("loader_bar_chaser");
            this.progressText = Layers.Menus.getText("loader_text");

            const barMask = Layers.Menus.getSprite("loader_bar_mask");
            if (barMask) {
                const mask = new PIXI.Graphics();
                mask.x = barMask.x;
                mask.y = barMask.y;
                mask.beginFill(0xff0000);
                mask.drawRect(0, 0, barMask.width, barMask.height);
                barMask.visible = false;
                bar.mask = mask;

                bar = mask;

                Layers.Menus.add(mask);
            }
        }

        this.loadBar = new LoadbarComponent(files, bar, chaser);

        this.loadBar.onChange.add(() => this.update());
    }

    public fileLoaded(resource: PIXI.loaders.Resource) {
        if (this.loadBar) {
            this.loadBar.fileLoaded(resource);
        }
    }

    /**
     * Quickly completes the loadbar and returns a Contract for when it's done
     */
    public loadComplete() {
        Services.sound.event(SoundEvent.preload_complete);

        if (this.loadBar) {
            return this.loadBar.loadComplete();
        } else {
            return Contract.empty();
        }
    }

    public destroy() {
        this.progressText = null;

        Layers.Background.defaultScene().execute();
        Layers.Menus.clear();
    }

    private update() {
        if (this.progressText) {
            this.progressText.text = Services.translations.get("prl.loa", { PROGRESS: Math.round(this.loadBar.currentPercent * 100) });
        }

        this.onProgress.dispatch(this.loadBar.currentPercent);
    }
}

export default PreloaderComponent;
